import React from "react";
import FormLayout from "../../layouts/FormLayout";
import { Typography } from "@mui/material";
import TheaterLoginForm from "../../components/TheaterLoginForm/TheaterLoginForm";
import logoViz from "../../assets/images/logo-viziona-white.png";

export default function TheaterLoginPage() {
  return (
    <FormLayout>
      <img src={logoViz} alt="logo-viziona" className="logo-viziona" />
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        color="primary.contrastText"
      >
        ¡Bienvenido!
      </Typography>
      <Typography
        variant="body1"
        align="center"
        gutterBottom
        color="primary.contrastText"
      >
        Ingresa los datos del Kiosco para ingresar
      </Typography>
      <TheaterLoginForm />
    </FormLayout>
  );
}
